export type Locale = "en" | "es";

export interface UIStrings {
  next: string;
  continueLabel: string;
  building: string;
  question: string;
  yourResult: string;
  whyWeAsk: string;
}

export const STRINGS: Record<Locale, UIStrings> = {
  en: {
    next: "Next",
    continueLabel: "Continue",
    building: "Building your result…",
    question: "Question",
    yourResult: "Your result",
    whyWeAsk: "Why do we ask this?",
  },
  es: {
    next: "Siguiente",
    continueLabel: "Continuar",
    building: "Preparando tu resultado…",
    question: "Pregunta",
    yourResult: "Tu resultado",
    whyWeAsk: "¿Por qué preguntamos esto?",
  },
};
